import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: stretch;
`

export const InputWrapper = styled.div`
  flex: 1;
  position: relative;
`

export const DropdownWrapper = styled.div`
  min-width: 120px;
`

export const BindingWrapper = styled.div`
  min-width: 200px;
`

export const AutoLabel = styled.span`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.tertiary};
  background: ${({ theme }) => theme.colors.background.primary};
  padding: 2px 6px;
  border-radius: 4px;
  pointer-events: none;
`
